module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-brands-400-273dc9bf9778fd37fa61357645d46a28.ttf";